module.exports = __webpack_public_path__ + "static/media/flight-attendant.52a67732.jpg";